import React from 'react'

const TextLoader = () => {
    return (
        <div className='bg-slate-300 h-3 rounded-lg animate-pulse w-full' />
    )
}

export default TextLoader